if (!customElements.get('product-tab-slider')) {
  customElements.define(
    'product-tab-slider',
    class ProductTabSlider extends HTMLElement {
      constructor() {
        super();
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableMobileSlider = this.dataset.enableMobileSlider === 'true';
        this.blockId = this.dataset.blockId;
      }

      connectedCallback() {
        window.addEventListener('resize', () => {
          this.destroySlider();
          this.init();
        });
        this.selectors = {
          sliderWrapper: '.product-tab-slider__items',
          nextEl: `.swiper-button-next__tab-${this.blockId}`,
          prevEl: `.swiper-button-prev__tab-${this.blockId}`,
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

        this.mobileItems = parseInt(this.dataset.mobileItems);
        if(this.enableSlider) {
          this.items = parseInt(this.dataset.items);
          this.tabletItems = parseInt(this.dataset.tabletItems);
        }

        this.sliderInstance = false;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);

        if (!this.enableSlider && !this.enableMobileSlider) return;
        if(mql.matches && this.enableMobileSlider || this.enableSlider) {
          this.init();
        }
      }

      init() {
        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        if ((mql.matches && this.enableMobileSlider) || (!mql.matches && this.enableSlider)) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
        const columnMobileGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap-mobile');
        const spaceBetweenMobile = parseFloat(columnMobileGap.replace('rem', '')) * 10;

        let setmobileView;
        this.mobileItems === 1 ? setmobileView = 1.2 : setmobileView = parseFloat(this.mobileItems + '.3');

        this.sliderOptions = {
          slidesPerView: setmobileView,
          spaceBetween: spaceBetweenMobile,
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            750: {
              slidesPerView: parseInt(this.tabletItems) || 3,
              spaceBetween: spaceBetween,
            },
            1024: {
              slidesPerView: parseInt(this.items) || 4,
              spaceBetween: spaceBetween,
            },
            1280: {
              slidesPerView: parseInt(this.items) || 4,
              spaceBetween: spaceBetween,
            },
          },
          loop: false,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions);
        this.sliderInstance.init();

        this.calcNavButtonsPosition();
        this.calcHeadingColumnHeight();
        this.fixQuickviewDuplicate();
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty(
            '--swiper-navigation-top-offset',
            parseInt(firstMedia.clientHeight) / 2 + 'px'
          );
        }
      }

      calcHeadingColumnHeight() {
        if (this.dataset.calcHeadingColumnHeight !== 'true') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.section.style.setProperty('--heading-column-height', firstMedia.clientHeight + 'px');
        }
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}
